import React from "react";
import { Timeline, Text, Title, Stack, Loader } from "@mantine/core";
import { useTranslation } from "react-i18next";

class UpdateTimeLineProps {
  activeStepNo: number;
  timelineItems: { icon: any; title: string; text: string; time: string }[];
}

export default function UpdateTimeline(props: UpdateTimeLineProps) {
  const { t } = useTranslation();
  const getTimelineItems = () => {
    const timelineItems = [];
    for (let i = 0; i < props.timelineItems.length; i++) {
      const { icon, title, text, time } = props.timelineItems[i];
      timelineItems.push(
        <Timeline.Item bullet={icon} title={title}>
          <Text color="dimmed" size="sm">
            {text}
          </Text>
          <Text size="xs" mt={4}>
            {time}
          </Text>
        </Timeline.Item>,
      );
    }
    return timelineItems;
  };

  return (
    <Stack m={"2rem auto"}>
      {props.activeStepNo >= 3 ? (
        <Title c={"blue"} order={2}>
          {t("UpdateCompleted")}
        </Title>
      ) : (
        <Title c={"orange"} order={2}>
          {t("Updating")} <Loader variant="dots" />
        </Title>
      )}
      <Timeline active={props.activeStepNo} bulletSize={30} lineWidth={4} color={"orange"}>
        {getTimelineItems()}
      </Timeline>
    </Stack>
  );
}
